import React from "react";
import ReactDOM from "react-dom";
import { gridLayoutInstance } from "component/orgaisms/gridViewportSection/index.js";
/** Full screen mode helper */
import { toggleFullScreen } from "core/screen/screenManager.js";
import ShowDICOM from "core/DICOMtag";
import PopupDICOMTags from "component/molecules/popupDICOMTags";
/** Messagging System */
import pubsub from "core/global/global";
import CustomEvent from "core/customEvent/index";
/** Tool */
import store from "core/store/";
import Config from "core/config/";
import { configure } from "react-hotkeys";
/**
 * React-Hotkeys Configuration
 */
configure({
  ignoreRepeatedEventsWhenKeyHeldDown: false //키가 눌러져 있는 경우, 동일한 이벤트 계속 발생되는 것을 허용
});
/**
 * Copy styles from a source document to a target.
 * @param {Object} source
 * @param {Object} target
 * @private
 */

function copyStyles(source: any, target: any) {
  Array.from(source.styleSheets).forEach((styleSheet: any) => {
    // For <style> elements
    let rules;
    try {
      rules = styleSheet.cssRules;
    } catch (err) {
      console.error(err);
    }
    if (rules) {
      const newStyleEl = source.createElement("style");

      // Write the text of each rule into the body of the style element
      Array.from(styleSheet.cssRules).forEach((cssRule: any) => {
        const { cssText, type } = cssRule;
        let returnText = cssText;
        // Check if the cssRule type is CSSImportRule (3) or CSSFontFaceRule (5) to handle local imports on a about:blank page
        // '/custom.css' turns to 'http://my-site.com/custom.css'
        if ([3, 5].includes(type)) {
          returnText = cssText
            .split("url(")
            .map((line: any) => {
              if (line[1] === "/") {
                return `${line.slice(0, 1)}${
                  window.location.origin
                }${line.slice(1)}`;
              }
              return line;
            })
            .join("url(");
        }
        newStyleEl.appendChild(source.createTextNode(returnText));
      });

      target.head.appendChild(newStyleEl);
    } else if (styleSheet.href) {
      // for <link> elements loading CSS from a URL
      const newLinkEl = source.createElement("link");

      newLinkEl.rel = "stylesheet";
      newLinkEl.href = styleSheet.href;
      target.head.appendChild(newLinkEl);
    }
  });
}

const HotKeyMap = {
  AppGlobalHotKeys: {
    keyMap: {
      ///

      ///

      ///
      /// Full screen mode
      ///
      FULL_SCREEN_MODE: "f",
      ///
      /// Move slice
      ///
      MOVE_BACK_ONE_SLICE: "left",
      MOVE_AHEAD_ONE_SLICE: { sequence: "right", action: "keydown" },
      MOVE_BACK_SLICES: "pageup",
      MOVE_AHEAD_SLICES: "pagedown",
      ///
      /// Select measurement tool
      ///
      SELECT_LENGTH_MEASUREMENT_TOOL: "l",
      SELECT_RECTANGLE_MEASUREMENT_TOOL: "r",
      SELECT_ELLIPSE_MEASUREMENT_TOOL: "e",
      SELECT_PENCIL_MEASUREMENT_TOOL: "p",
      SELECT_ANGLE_MEASUREMENT_TOOL: "a",
      SELECT_COBBANGLE_MEASUREMENT_TOOL: "c",
      ///
      /// Select zoom in/out tool
      ///
      SELECT_ZOOM_TOOL: "z",
      ///
      /// Select pan tool
      ///
      SELECT_PAN_TOOL: "m",
      ///
      /// Initialize zoom/pan state
      ///
      INITIALIZE_VIEW_STATE: "ctrl+0",
      ///
      /// Select contrast tool
      ///
      SELECT_CONTRAST_TOOL: "w",
      /// Change window level by preset
      SELECT_CONTRAST_DEFAULT: "0",
      SELECT_CONTRAST_FULLDYNAMIC: "1",
      SELECT_CONTRAST_CT_ABDOMEN: "2",
      SELECT_CONTRAST_CT_ANGIO: "3",
      SELECT_CONTRAST_CT_BONE: "4",
      SELECT_CONTRAST_CT_BRAIN: "5",
      SELECT_CONTRAST_CT_CHEST: "6",
      SELECT_CONTRAST_CT_LUNG: "7",
      SELECT_CONTRAST_NEGATIVE: "8",
      ///
      /// Info tool
      ///
      TOGGLE_ANNOTATION: "t", // on/off annotation
      SHOW_DCM_TAG_TABLE: "i", // Show dicom tag table
      OPEN_SHORTCUT_PAGE_IN_DOCUMENTATION: "s", // Open shortcut page in documentation
      OPEN_DOCUMENTATION: "f1" // Open documentation
    },
    handlers: {
      ///
      ///
      ///
      FULL_SCREEN_MODE: () => {
        toggleFullScreen();
      },
      ///
      /// Move slice handlers
      ///
      MOVE_BACK_ONE_SLICE: () => {
        pubsub.publish(CustomEvent.Messages.SET_SCROLL_INDEX_ADD, {
          displacement: -1
        });
      },
      MOVE_AHEAD_ONE_SLICE: () => {
        pubsub.publish(CustomEvent.Messages.SET_SCROLL_INDEX_ADD, {
          displacement: 1
        });
      },
      MOVE_BACK_SLICES: () => {
        pubsub.publish(CustomEvent.Messages.SET_SCROLL_INDEX_ADD, {
          displacement: -10
        });
      },
      MOVE_AHEAD_SLICES: () => {
        pubsub.publish(CustomEvent.Messages.SET_SCROLL_INDEX_ADD, {
          displacement: 10
        });
      },

      ///
      /// Initialize zoom/pan state
      ///
      INITIALIZE_VIEW_STATE: () => {
        pubsub.publish(CustomEvent.Messages.SET_VIEW_POSITION_INITIALIZE, {});
      },
      ///
      /// Select contrast tool
      ///
      SELECT_CONTRAST_TOOL: () => {
        /// active window level tool
        pubsub.publish(CustomEvent.Messages.SET_ACTIVE_TOOL, "Contrast");
        pubsub.publish(CustomEvent.Messages.SET_ACTIVE_TOOLBAR_BUTTON, {
          id: "contrast",
          active: true
        });
      },

      TOGGLE_ANNOTATION: () => {
        ShowDICOM.toggleIsShowDICOMTag();
        (pubsub as any).publish(CustomEvent.Messages.TOGGLE_DICOM_TAG, {});
      }

      // OPEN_SHORTCUT_PAGE_IN_DOCUMENTATION: () => {
      //   window.open(Config.DOCUMENTATION_SHORTKEY_PAGE_URL, "_blank");
      // },
      // OPEN_DOCUMENTATION: () => {
      //   window.open(Config.DOCUMENTATION_URL, "_blank");
      // }
    }
  }
};

export default HotKeyMap;
